import React, { Fragment, useEffect, useMemo, useState } from "react";
import style from "./viewUserPayment.module.css";
import timeline from "../../../assets/images/timeline/timeline.jpeg";
import { useLocation, useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../constants/Constants";
import { ErrorToast } from "../../../components/toastMessage";
import axios from "axios";
import { formatDate } from "../../../utils/date";
import { useSetStuffToRenderOnNavbar } from "../../../contexts/NavbarCommonSpace";
import {
  useAllFields,
} from "../../../hooks/applications.hooks";

interface Comment {
  level: string;
  status: string;
  comment_text: string;
  reviewer_id: string;
  date: string;
}

import {
  useApplication,
  useApplicationFormSteps,
  useGeneratedDocs,
} from "../../../hooks/applications.hooks";
import { ShowField } from "../../../components/ViewApplication/ViewApplication";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import { _axios } from "../../../utils/axios";

interface ApplicationDetails {
  id: any,
  application_id: any;
  status: string;
  project_name: string;
  plot_owner_s_name: string;
  unauthorized_layout_name: string;
  mauja: string;
  plot_no: string;
  name_of_service: string;
}


const ViewUserPayment: React.FC = () => {
  const location = useLocation();
  const { user } = location.state;
  console.log('user', location.state)
  const navigate = useNavigate();
  const applicationId = user.application_id;
  const [comments, setComments] = useState<Comment[]>([]);
  const [applicationDetails, setApplicationDetails] = useState<ApplicationDetails | null>(null);
  const [sortedComments, setSortedComments] = useState<Comment[]>([]);
  // const id = location.state?.id;
  const id = applicationDetails?.id;
  const {
    isError: isError1,
    isFetching: isFetching1,
    data: application,
  } = useApplication({ id });

  const [latePaymentDetails, setLatePaymentDetails] = useState<{
    baseAmount: number;
    interestAccumulated: number;
    totalAmount: number;
    daysPending: number;
  } | null>(null);

  useEffect(() => {
    if (application?.applicationId && id) {
      _axios.post("/uploadReceipt/getTotalAmount", {
        application_id: id
      })
      .then(res => {
        if (res.data && res.data.success) {
          const data = res.data;
          if (data.interestAccumulated > 0) {
            setLatePaymentDetails({
              baseAmount: data.baseAmount,
              interestAccumulated: data.interestAccumulated,
              totalAmount: data.totalAmount,
              daysPending: data.daysPending
            });
          }
        }
      })
      .catch(err => console.error("Error fetching late fee details in ViewUserPayment:", err));
    }
  }, [application, id]);

  const normalizedApplication: Record<string, any> = {
    ...application,
    // map camelCase → snake_case
    type_of_application_submitter:
        application?.type_of_application_submitter ??
        application?.typeOfApplicationSubmitter,

    submitted_by:
        application?.submitted_by ??
        application?.submittedBy,
  };

  const {
    data: result,
    isError: isError2,
    isFetching: isFetching2,
  } = useApplicationFormSteps(Number(application?.name_of_service));

  const {
    isFetching: isFetching3,
    isError: isError3,
    data: allFields,
  } = useAllFields({
    serviceName: String(application?.name_of_service || ""),
  });

  const steps = result?.data || [];

  const selectedFields = useMemo(
    () =>
      (steps || [])
        .filter((e) => !["Documents", "NOC"].includes(e.type))
        .flatMap((e) => e.fields || [])
        .reduce<Map<string, true>>((acc, e) => acc.set(e.uid, true), new Map()),
    [steps]
  );

  const fetchComments = async (id: any) => {
    const apiUrl = `${BASE_URL}/api/paymentList/comment/${id}`;
    console.log('id', id)
    try {
      const response = await axios.get(apiUrl);
      const commentsData = response.data.data;
      // Sort comments by date in ascending order
      const sorted = commentsData.sort((a: Comment, b: Comment) => {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
      });
      setSortedComments(sorted);
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  useEffect(() => {

    fetchComments(id);
  }, [id]);

  useEffect(() => {
    const fetchApplicationDetails = async () => {
      console.log('appId', applicationId)
      try {
        const response = await _axios.get(`${BASE_URL}/api/paymentList/application/${applicationId}`);
        setApplicationDetails(response.data.data);
      } catch (error) {
        console.error("Error fetching application details:", error);
        ErrorToast("Failed to fetch application details");
      }
    };

    fetchApplicationDetails();
  }, [applicationId]);

  const setStuff = useSetStuffToRenderOnNavbar();

  useEffect(() => {
    if (applicationDetails) {
      setStuff(
        <div className="md:ml-auto md:mr-8">
          <p className="text-grey-600">
            <span className="w-28 font-semibold inline-block">
              Application ID
            </span>
            <span className="text-grey-600 font-semibold mx-2">:</span>
            <span>{applicationDetails.application_id || "Nil"}</span>
          </p>
          <p className="text-grey-600 flex items-center">
            <span className="w-28 text-grey-600 font-semibold inline-block">
              Status
            </span>
            <span className="text-grey-600 font-semibold mx-2">:</span>
            <span className="text-primary">
              {applicationDetails.status || "Nil"}
            </span>
          </p>
        </div>
      );
    } else {
      setStuff(null);
    }

    return () => setStuff(null);
  }, [setStuff, applicationDetails]);

  let i = 0;

  return (
    <div className="p-4 w-full box-border">
      <div className={style.bodyHeading}>
        <BoxComponent>
          <div className={style.whiteContainer}>
            <div className={style.headingBar}>
              <div className={style.pageHeading}>
                <p className={style.bodyTitle}>Application Details</p>

              </div>
            </div>
            <div className={style.yellowBox}>
              <div className={style.contentYellowBox}>
                <p className={style.paymentPrompt}>Payment : Pending</p>
                <button className={style.payButton} onClick={() => navigate('/pay-now', { state: { user, id } })}>Pay Now</button>
              </div>
            </div>

            <div className={style.bodyContentWrapper}>
              <div className={style.timelineBox}>
                <div className="d-flex p-3" style={{ justifyContent: "space-between", alignItems: "center", position: "relative" }}>
                  <div className={style.greyLine}></div>

                  {sortedComments.slice(0, 12).map((comment, index) => {
                    const isValidComment = isValidTimelineComment(comment.level, comment.status);

                    if (isValidComment) {

                      const previousComment = index > 0 ? sortedComments[index - 1] : null;
                      const nextComment = index < sortedComments.length - 1 ? sortedComments[index + 1] : null;
                      const isDifferentFromPrevious = !previousComment || (previousComment.level !== comment.level || previousComment.status !== comment.status);
                      const isDifferentFromNext = !nextComment || (nextComment.level !== comment.level || nextComment.status !== comment.status);

                      if (isDifferentFromPrevious && isDifferentFromNext) {
                        return (
                          <div key={index} className={style.outerBorder} style={{ border: `solid ${getCircleColor(comment.level, comment.status)}` }}>
                            <div className={style.whiteCircleBorder}>
                              <div className={`${style.circleCustom} p-2 text-white`} style={{ backgroundColor: getCircleColor(comment.level, comment.status) }}>
                                {getSymbol(comment.level, comment.status)}
                              </div>
                              <span className={style.timelineDate}>{formatDate(comment.date)}</span>
                            </div>
                          </div>
                        );
                      } else {

                        return null;
                      }
                    } else {
                      return null;
                    }
                  })}
                </div>
              </div>
              <div className={style.detailsBox}>
                <div className={style.statusDetails}>
                  {(allFields || [])
                    .filter((e) => selectedFields.has(e.uid) || !!normalizedApplication?.[e.uid])
                    .map((e) => (
                      <ShowField
                        field={e}
                        index={++i}
                        key={`field-${e.id}`}
                        data={normalizedApplication || {}}
                      />
                    ))}
                </div>
                {latePaymentDetails && (
                  <div className="mt-8 border-t pt-6">
                    <h4 className="text-center text-grey-600 font-semibold mb-8 text-2xl">
                      Late Payment Interest Calculations
                    </h4>
                    <div className="flex flex-col">
                      <div className="flex items-center space-x-2 md:space-x-6 mb-2">
                        <p className="text-grey-600 text-sm md:text-base font-semibold shrink-0 basis-1/3">
                          {`${i + 1}. Base Demand Note Amount`}
                        </p>
                        <p className="text-grey-600 text-sm md:text-base shrink-0">:</p>
                        <p className="text-grey-600 text-sm md:text-base grow inline-block min-w-[100px] text-wrap break-words">
                          {latePaymentDetails.baseAmount} INR
                        </p>
                      </div>
                      <div className="flex items-center space-x-2 md:space-x-6 mb-2">
                        <p className="text-grey-600 text-sm md:text-base font-semibold shrink-0 basis-1/3">
                          {`${i + 2}. Late Payment Penalty (1.5% Compounded)`}
                        </p>
                        <p className="text-grey-600 text-sm md:text-base shrink-0">:</p>
                        <p className="text-grey-600 text-sm md:text-base grow inline-block min-w-[100px] text-wrap break-words text-red-500">
                          {latePaymentDetails.interestAccumulated} INR ({latePaymentDetails.daysPending} days pending)
                        </p>
                      </div>
                      <div className="flex items-center space-x-2 md:space-x-6 mb-2">
                        <p className="text-grey-600 text-sm md:text-base font-semibold shrink-0 basis-1/3">
                          {`${i + 3}. Total Recalculated Amount of Demand`}
                        </p>
                        <p className="text-grey-600 text-sm md:text-base shrink-0">:</p>
                        <p className="text-grey-600 text-sm md:text-base grow inline-block min-w-[100px] text-wrap break-words font-bold">
                          {latePaymentDetails.totalAmount} INR
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className={style.buttonSection}>
                <button className={style.closeButton} onClick={() => navigate('/payment-list')}>Back</button>
              </div>
            </div>
          </div>
        </BoxComponent>
      </div>
    </div>
  );
}

const isValidTimelineComment = (level: string, status: string) => {
  const lowercaseLevel = level.toLowerCase();

  // conditions
  if (["level 1", "level 2", "level 3"].includes(lowercaseLevel) && status === "Draft") {
    return true;
  }
  if (["level 1", "level 2", "level 3"].includes(lowercaseLevel)) {
    if (status === "Approved" || status === "Returned") return true;
  }
  if (["level 2", "level 3"].includes(lowercaseLevel)) {
    if (status === "Payment Pending" || status === "Payment Review") return true;
  }
  if (["level 1", "level 2 payment", "level 3 payment"].includes(lowercaseLevel)) {
    if (status === "Approved" || status === "Returned") return true;
  }
  if (lowercaseLevel === "level 3" && status === "Completed") {
    return true;
  }

  // Default condition
  return false;
};

const getCircleColor = (level: string, status: string) => {
  const lowercaseLevel = level.toLowerCase();
  if (["level 1", "level 2", "level 3"].includes(lowercaseLevel) && status === "Draft") {
    return "#2B66FF"; // Blue
  }
  if (["level 1", "level 2", "level 3"].includes(lowercaseLevel)) {
    if (status === "Approved") return "#E9B925"; // Yellow
    if (status === "Returned") return "#FF5A5A"; // Red
    if (status === "Rejected") return "#FF5A5A"; // Red
  }
  if (["level 2", "level 3"].includes(lowercaseLevel)) {
    if (status === "Payment Pending") return "#ADA7A7"; // Grey
    if (status === "Payment Review") return "#FFC0CB"; // Pink
  }
  if (["level 1", "level 2 payment", "level 3 payment"].includes(lowercaseLevel)) {
    if (status === "Approved") return "#E9B925"; // Yellow
    if (status === "Returned") return "#FF5A5A"; // Red
    if (status === "Rejected") return "#FF5A5A"; // Red
  }
  if (lowercaseLevel === "level 3" && status === "Completed") {
    return "#25B101"; // Green
  }
  // Default color
  return "#FFFFFF";
};

const getSymbol = (level: string, status: string) => {
  const lowercaseLevel = level.toLowerCase();
  if (["level 1", "level 2", "level 3"].includes(lowercaseLevel) && status === "Draft") {
    return "U";
  }
  if (["level 1", "level 2", "level 3"].includes(lowercaseLevel)) {
    if (status === "Approved") return "Y";
    if (status === "Returned") return "R";
  }
  if (["level 2 payment", "level 3 payment"].includes(lowercaseLevel)) {
    if (status === "Approved") return "Y";
    if (status === "Returned") return "R";
  }
  if (lowercaseLevel === "level 3" && status === "Completed") {
    return "C";
  }
  // Default symbol
  return "";
};

export default ViewUserPayment;
